import { Reveal } from "@/components/Reveal";
import { CountUp } from "@/components/CountUp";
import { STATS, FEES } from "@/data/content";

export const TrustIndicators = () => (
  <section className="py-20 sm:py-28 border-b border-zinc-200" data-testid="trust">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest mb-3">Proven, measurable outcomes</p>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div className="border-l-2 border-forest/30 pl-5">
              <div className="text-2xl sm:text-4xl md:text-5xl font-extrabold tracking-tighter text-ink whitespace-nowrap">
                {s.value ? s.value : <CountUp end={s.end} prefix={s.prefix || ""} suffix={s.suffix || ""} duration={2000} />}
              </div>
              <div className="mt-2 text-sm text-zinc-500 leading-snug">{s.label}</div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-16 rounded-3xl border border-zinc-200 bg-white p-8 sm:p-10">
          <div className="rounded-2xl bg-ink text-white p-6 sm:p-8 mb-8" data-testid="fee-highlight">
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest-light mb-3">Our promise</p>
            <h3 className="text-2xl sm:text-4xl font-extrabold tracking-tight leading-[1.05]">
              No success fee <span className="text-forest-light">unless we recover.</span>
            </h3>
            <p className="mt-3 text-sm sm:text-base text-zinc-300 max-w-2xl">
              Only a one-time registration fee applies. The success fee is payable only upon successful recovery of your claim.
            </p>
          </div>
          <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest mb-6">Transparent, honest pricing</p>
          <div className="grid md:grid-cols-3 gap-8">
            {FEES.map((f, i) => (
              <div key={f.title} className="relative pl-6" data-testid={`fee-${i}`}>
                <span className="absolute left-0 top-1.5 h-2.5 w-2.5 rounded-full bg-forest" />
                <h3 className="font-bold text-ink leading-snug">{f.title}</h3>
                <p className="mt-2 text-sm text-zinc-500 leading-relaxed">{f.copy}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default TrustIndicators;
